export default __webpack_public_path__ + "static/narrow-c0abf0c829927406bf8a4853adecc708.png";